import { createContext, useState } from "react";

export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {

    const mediaQuery = window.matchMedia("(max-width: 991px)");
    const [sidebar, setSidebar] = useState(mediaQuery.matches ? false : true);

    const toggleSidebar = () => setSidebar(!sidebar);

    // Get user from localStorage
    const storedUser = localStorage.getItem("user");
    const userdata = storedUser ? JSON.parse(storedUser) : null;

    const permissions = userdata?.permissions || [];
    const hasPermission = (requiredPermission) => {
        if (!requiredPermission) return true;

        return permissions.some(
            (p) => p.name.toLowerCase() === requiredPermission.toLowerCase()
        );
    };
    return (
        <SidebarContext.Provider
            value={{
                sidebar,
                toggleSidebar,
                hasPermission,  
                permissions,
                userdata
            }}
        >
            {children}
        </SidebarContext.Provider>
    )
}